// extracted by mini-css-extract-plugin
export default {"base":"vp_EAfxr","eyebrow":"vp_qW1Ko","title":"vp_d2sam","lead":"vp_lJBLO","compact":"vp_BhA1h"};